var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.modalId,
        titleHtml: _vm.$t(
          "ui.components.users.profile.contact_modal.modal_title_html",
          { name: _vm.user.display_name }
        ),
      },
      on: { shown: _vm.handleModalShown },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex w-100 justify-content-end" },
                [
                  _vm.user.policies.conversations && !_vm.profileOwner
                    ? _c("ci-button", {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal",
                            value: `modal-direct-message--${_vm.user.id}`,
                            expression: "`modal-direct-message--${user.id}`",
                          },
                        ],
                        attrs: {
                          variant: "filled-primary",
                          gated: !_vm.$user.signedIn,
                          icon: "mdi-message-text",
                          label: _vm.$t(
                            "ui.components.users.profile.contact_modal.send_message"
                          ),
                        },
                        on: { click: _vm.handleSendMessageClick },
                      })
                    : _vm._e(),
                  _vm.profileOwner && !_vm.contactComplete
                    ? _c("ci-button", {
                        attrs: {
                          icon: "mdi-plus",
                          label: _vm.$t(
                            "ui.components.users.profile.contact_modal.action"
                          ),
                          to: {
                            name: _vm.$routes.USERS_EDIT,
                            params: { id: _vm.user.slug },
                            hash: "#areaofcontact",
                          },
                          variant: "outline-primary",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.user.contact.phone
        ? _c("div", { staticClass: "phone d-flex align-items-center py-2" }, [
            _c("div", {
              staticClass: "text-primary mdi mdi-24px mdi-cellphone mx-3",
            }),
            _c(
              "div",
              { staticClass: "d-flex flex-column justify-content-start" },
              [
                !_vm.showPhoneNumber
                  ? _c("span", {
                      staticClass:
                        "phone-color phone-number cursor-pointer font-weight-semi",
                      attrs: { "data-cy": "phone-cloaked" },
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t(
                            "ui.components.users.profile.contact_modal.show_phone"
                          )
                        ),
                      },
                      on: {
                        click: function ($event) {
                          _vm.showPhoneNumber = true
                        },
                      },
                    })
                  : _c(
                      "span",
                      {
                        staticClass: "text-primary phone-number cursor-pointer",
                        attrs: { "data-cy": "phone-present" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handlePhoneClick.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("strong", {
                          domProps: {
                            textContent: _vm._s(_vm.user.contact.phone),
                          },
                        }),
                      ]
                    ),
              ]
            ),
          ])
        : _vm._e(),
      _vm.user.company.name
        ? _c("div", { staticClass: "company d-flex align-items-center py-2" }, [
            _c("div", {
              staticClass: "text-primary mdi mdi-24px mdi-domain mx-3",
            }),
            _c(
              "div",
              [
                _c("span", {
                  staticClass: "d-block",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t(
                        "ui.components.users.profile.contact_modal.company"
                      )
                    ),
                  },
                }),
                _vm.user.company.url
                  ? [
                      _c(
                        "a",
                        {
                          attrs: { href: _vm.user.company.url },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.handleCompanyNameClick.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(_vm.user.company.name),
                            },
                          }),
                        ]
                      ),
                    ]
                  : [
                      _c("strong", {
                        domProps: {
                          textContent: _vm._s(_vm.user.company.name),
                        },
                      }),
                    ],
              ],
              2
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "location d-flex py-2 align-items-center" },
        [
          _c("div", { staticClass: "text-primary mdi mdi-24px mdi-home mx-3" }),
          [
            _c("div", [
              _c("span", {
                staticClass: "d-block",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("ui.components.users.profile.contact_modal.address")
                  ),
                },
              }),
              _vm.user.location.street
                ? _c("strong", {
                    staticClass: "d-block",
                    domProps: { textContent: _vm._s(_vm.user.location.street) },
                  })
                : _vm._e(),
              _vm.joinedAddress
                ? _c("strong", {
                    staticClass: "d-block",
                    domProps: { textContent: _vm._s(_vm.joinedAddress) },
                  })
                : _vm._e(),
            ]),
          ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }